import Header from '../components/general/Header';
import Footer from '../components/general/Footer';
import useIsMobile from '../utils/hooks/useIsMobile';
import s from '../styles/pages/MerchStore.module.css';
import site from '../data/master.json';

const covers = site.discography.songs.map((song) => song.image);

export default function MerchStore() {
  const isMobile = useIsMobile();

  return (
    <div className={s.container}>
      <Header />

      <section className={isMobile ? s.heroMobile : s.hero}>
        <div className={s.wall}>
          {[...covers, ...covers].map((src, i) => (
            <div key={i} className={s.cell}>
              <img src={src} alt="" className={s.cover} />
            </div>
          ))}
        </div>

        <div className={s.overlay} />

        <div className={s.content}>
          <span className={s.eyebrow}>Merch Store</span>
          <h1 className={isMobile ? s.headlineMobile : s.headline}>Coming Soon</h1>
          <p className={s.subhead}>
            Don't Get Attached hoodies? Wildfire sweatpants?? SEVEN STARS UNDERWEAR??? There's more than just a new album coming.
          </p>
        </div>
      </section>

      <Footer data={site.footer} />
    </div>
  );
}